import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, orderPickupButtonMobile } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/a2TLHtUTBF7l6EtnqqGm/locations/SvIg38SVeNRlB5OKrXDp`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="95%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/a2TLHtUTBF7l6EtnqqGm/locations/SvIg38SVeNRlB5OKrXDp`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="100%"
                  maxWidth="290px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
